import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.694 9.185C8.004 9.675 9.88 10 12 10s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.766C18.99 8.17 19 8.026 19 8c0-.026-.01-.17-.292-.42-.28-.248-.744-.518-1.402-.765C15.996 6.325 14.12 6 12 6s-3.997.324-5.306.815c-.658.247-1.121.517-1.402.766C5.01 7.83 5 7.974 5 8c0 .026.01.17.292.42.28.248.744.518 1.402.765zm-2.729.731C3.437 9.448 3 8.803 3 8c0-.803.437-1.448.965-1.916.53-.469 1.238-.846 2.027-1.142C7.578 4.347 9.702 4 12 4c2.297 0 4.422.347 6.008.942.79.296 1.498.673 2.027 1.142C20.562 6.552 21 7.197 21 8c0 .803-.438 1.448-.965 1.916-.53.469-1.238.846-2.027 1.142-1.586.595-3.71.942-6.008.942-2.297 0-4.422-.348-6.008-.942-.79-.296-1.498-.673-2.027-1.142zM6.694 13.185C8.004 13.675 9.88 14 12 14s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.766.282-.25.292-.394.292-.419h2c0 .803-.438 1.448-.965 1.916-.53.469-1.238.846-2.027 1.142-1.586.595-3.71.942-6.008.942-2.297 0-4.422-.348-6.008-.942-.79-.296-1.498-.673-2.027-1.142C3.437 13.448 3 12.803 3 12h2c0 .025.01.17.292.42.28.248.744.518 1.402.765z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.694 17.185C8.004 17.675 9.88 18 12 18s3.997-.324 5.306-.815c.658-.247 1.121-.517 1.402-.765.282-.25.292-.395.292-.42h2c0 .803-.438 1.448-.965 1.916-.53.469-1.238.846-2.027 1.142-1.586.595-3.71.942-6.008.942-2.297 0-4.422-.348-6.008-.942-.79-.296-1.498-.673-2.027-1.142C3.437 17.448 3 16.803 3 16h2c0 .026.01.17.292.42.28.248.744.518 1.402.765z"
      fill="currentColor"
    />
  </svg>
);
